import React from "react";
import { SourceSystem } from "./BaseSourceSystem";
import greenTick from "../../images/green-tick.svg";

export class ValueMyCarSourceSystem extends SourceSystem {
  constructor(redirectUri: string, exitUri: string, navigate: INavigate) {
    super(redirectUri, exitUri, navigate);
    this.name = "value-my-car";
    this.photosRequired = true;
    this.errorUri = redirectUri || "/";
    this.stepCount = 16;
    this.haveHeaderExit = false;
    this.quickValuation = false;
    this.showPrivacyStatement = false;
    this.photoGalleryContent = {
      stepNumber: 14
    };
    this.showEstimatedOfferPartExchange = true;
    this.isPartExchangeCustomer = true;
    this.showBranchValuationContent = false;
    this.analyticSearchParam = "PX";
    this.analyticsJourney = "Sales customer";
    this.initialOfferContent = {
      offerLabel: "Your estimated valuation",
      subheaderTitle: "Your valuation",
      cta: "Save and submit valuation",
      ctaMicro: "Or, continue with your initial valuation",
      footerCTA: "Next: Upload photos",
      assumptionsCopy:
        "*Your personalised offer is subject to a branch valuation and is based on these assumptions.",
      renderImageUpload: true,
      stepNumber: 15,
      whatHappensNextContent: (
        <>
          <p>
            Once you’ve submitted your answers and photos, these will be sent to
            your Product Consultant to review.
          </p>
          <p>
            They will then give you a call to discuss your valuation and arrange
            a full branch appraisal.
          </p>
          <p>
            Your final price will then be agreed in consultation with you at
            your branch appraisal.
          </p>
        </>
      ),
      assumptionsContent: (
        <>
          <div className="ch-text--left ch-display--flex">
            <img className="ch-mr--2" src={greenTick} alt="grey tick" />
            <span>
              This <span className="ch-text--bold">price is a guide</span> based
              on your answers and{" "}
              <button
                className="ch-btn ch-btn--link ch-pa--0 ch-fs--2"
                data-gtm-track="interaction"
                data-gtm-track-label="These assumptions from estimated"
                onClick={() => navigate("/assumptions")}
              >
                these assumptions
              </button>
              .
            </span>
          </div>
          <div className="ch-text--left ch-display--flex   ">
            <img className="ch-mr--2" src={greenTick} alt="grey tick" />
            <p className="ch-mt--1 ch-mb--0">
              Estimated valuations are subject to a branch appraisal.
            </p>
          </div>
          <div className="ch-text--left ch-display--flex   ">
            <img className="ch-mr--2" src={greenTick} alt="grey tick" />
            <p className="ch-mt--1 ch-mb--0">
              Your final price will be agreed in consultation with you.
            </p>
          </div>{" "}
        </>
      )
    };

    this.handleAssumptionsOnSubmit = (allQuestionsAnswered) => {
      if (allQuestionsAnswered) {
        navigate("/estimated-offer");
      } else {
        navigate("/initial-offer");
      }
    };

    this.getCTAValue = (pageName: string | undefined) => {
      const pathname = pageName || window.location.pathname;
      let result = "";
      switch (pathname) {
        case "/value-my-vehicle/mileage":
          result = "Next: Number of keys";
          break;
        case "/value-my-vehicle/keys":
          result = "Next: Service history";
          break;
        case "/value-my-vehicle/service-history":
          result = "Next: Vehicle usage";
          break;
        case "/value-my-vehicle/vehicle-usage":
          result = "Next: Exterior bodywork";
          break;
        case "/value-my-vehicle/bodywork":
          result = "Next: Tyres";
          break;
        case "/value-my-vehicle/tyres":
          result = "Next: Your trims/ alloys";
          break;
        case "/value-my-vehicle/wheels":
          result = "Next: Your interior";
          break;
        case "/value-my-vehicle/interior":
          result = "Next: Mechanical and electrics";
          break;
        case "/value-my-vehicle/mechanics":
          result = "Next: Upload photos";
          break;
        default:
          result = "Continue";
      }
      return result;
    };
  }
}
